import React from "react";
import "./Footer.css";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="sb-footer">
        <div className="sb-footer-links">
          {/* Resources */}
          <div className="sb-footer-links-div">
            <h4>Resources</h4>
            <a href="#" aria-label="Resource Center">
              <p>Resource Center</p>
            </a>
            <a href="#" aria-label="Testimonials">
              <p>Testimonials</p>
            </a>
            <a href="#" aria-label="STV">
              <p>STV</p>
            </a>
          </div>

          {/* Company */}
          <div className="sb-footer-links-div">
            <h4>Company</h4>
            <Link to="timeline-section" spy={true} smooth={true} offset={-65}>
              <span>About</span>
            </Link>
            <a href="/press">
              <p>Press</p>
            </a>
            <a href="/career">
              <p>Career</p>
            </a>
            <Link to="contact-section" spy={true} smooth={true} offset={-65}>
              <span>Contact</span>
            </Link>
          </div>

          {/* Socials */}
          <div className="sb-footer-links-div">
            <h4>Socials</h4>
            <div className="socialmedia">
              <p>
                <a
                  href="https://www.linkedin.com/company/mafkin-robotics"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Mafkin Robotics on LinkedIn"
                >
                  <img src="linkedin1.png" alt="LinkedIn" />
                </a>
              </p>
              <p>
                <a href="#" aria-label="Mafkin Robotics on Twitter">
                  <img src="twitter.png" alt="Twitter" />
                </a>
              </p>
              <p>
                <a href="#" aria-label="Mafkin Robotics on Facebook">
                  <img src="facebook.png" alt="Facebook" />
                </a>
              </p>
              <p>
                <a href="#" aria-label="Mafkin Robotics on Instagram">
                  <img src="instagram.png" alt="Instagram" />
                </a>
              </p>
            </div>
          </div>
        </div>

        <hr />

        <div className="sb-footer-below">
          <div className="sb-footer-copyright">
            <p>
              &copy; {new Date().getFullYear()} Mafkin Robotics. All Rights Reserved.
            </p>
          </div>

          <div className="sb-footer-below-links">
            <a href="#"><div><p>Terms &amp; Conditions</p></div></a>
            <a href="#"><div><p>Privacy</p></div></a>
            <a href="#"><div><p>Security</p></div></a>
            <a href="#"><div><p>Cookie Declaration</p></div></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
